import React, { useEffect, useRef } from "react";
//import { scrollToSection } from "../../../utils/scrollToSection";
import Typed from "typed.js";

// import particlesConfig from "../../../utils/particlesConfig";

const Home = () => {

   // Create a reference for the element that will contain the typed text
   const typedElement = useRef(null);

   useEffect(() => {
     const options = {
       strings: [
        "CustomWeb Development",
        "Creative Web Design",
        "Mobile App Solutions",
        "API Integration Services",
        "WordPress Expertise",
        "ECommerce Development"
       ],
       typeSpeed: 100,
       backSpeed: 50,
       loop: true
     };
 
     // Initialize Typed.js on the referenced element
     const typed = new Typed(typedElement.current, options);
 
     // Cleanup Typed instance on unmounting to prevent memory leaks
     return () => {
       typed.destroy();
     };
   }, []);

  //  useEffect(() => {
  //   // Must be loaded globally first, so `window.particlesJS` is defined
  //   if (window.particlesJS) {
  //     window.particlesJS("particles-js", particlesConfig());
  //   }
  // }, []);

  return (
    <div className="landing">
      <div className="overlay"></div>
      {/* ...other content... */}
      <div className="container">
        <div className="row">
          <div className="col-xl-8 col-lg-9 col-md-11 col-sm-12 col-12 landing-inner">
            <h2 data-aos="fade-up">
              Spadez Solutions  <br/> 
            <span ref={typedElement}></span>
            </h2>
            <p data-aos="fade-up" data-aos-delay="300">
              Welcome to Spadez Solutions your trusted partner for all inclusive, cost  <br/>
              effective web and mobile development, crafted by a team of innovative,<br/> emerging talent.
            </p>
            <div className="social" data-aos="fade-up" data-aos-delay="100">
              <a href="mailto:info@spadezgroup.com"><i className="fa-solid fa-envelope"></i></a>
              <a href="https://www.facebook.com/SpadezGroup/" target="_blank" rel="noreferrer"><i className="fa-brands fa-facebook"></i></a>
              <a href="https://in.linkedin.com/company/spadez-solutions-priv-limited" target="_blank" rel="noreferrer"><i className="fa-brands fa-linkedin"></i></a>
              <a href="https://www.upwork.com/agencies/425300268729659393/" target="_blank" rel="noreferrer"><i className="fa-brands fa-upwork"></i></a>
            </div>
            {/* <div className="d-flex justify-content-start buttons">
              <button className="btn-custom btn-primary" onClick={() => scrollToSection("#contact-us")}>Get Started</button>
              <button className="btn-custom btn-default" onClick={() => scrollToSection("#services")}>
                <i className="fas fa-play-circle"></i> See Service
              </button>
            </div> */}
          </div>
        </div>
      </div>
      {/* <div id="particles-js" style={{ width: '100%', height: '100vh' }} /> */}
    </div>
  );
};

export default Home;
